module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// /Volumes/Data/projecten/uw-schilderwerk-website/node_modules/core-js/modules/_iter-step.js
// module id = 68
// module chunks = 11